import PropTypes from 'prop-types';
import classnames from 'classnames';
import React, { Component } from 'react';
import CapacitorRipple from '../capacitor/Ripple';
import styles from '../common/PersonalPlaylistItem.css';
import Image from '../util/Image';
import { SEARCH_IMAGE_DIMS } from '../../lib/imgix';
import { injectIntl, intlShape, defineMessages } from 'react-intl';

const messages = defineMessages({
  addToPlaylist: {
    id: 'playlist.add-to-playlist-btn.aria-label',
    defaultMessage: 'Add to playlist {playlistTitle}',
  },
});

class PersonalPlaylistListItem extends Component {
  static propTypes = {
    playlist: PropTypes.object.isRequired,
    onItemClick: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  onClick = () => {
    const { playlist, onItemClick } = this.props;
    onItemClick(playlist);
  };

  render() {
    const { playlist } = this.props;

    return (
      <div className={styles.component}>
        <button
          onClick={this.onClick}
          className={classnames('dummy-btn', styles.playlistButton)}
          aria-label={this.props.intl.formatMessage(messages.addToPlaylist, {
            playlistTitle: playlist.title,
          })}
        >
          <CapacitorRipple />
        </button>
        <div className={styles.cover}>
          <Image
            src={playlist.imageUrl}
            className={styles.bg}
            width={SEARCH_IMAGE_DIMS.w}
            height={SEARCH_IMAGE_DIMS.h}
            alt=""
          />
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            <span>{playlist.title}</span>
          </div>
          <span className={styles.copyrightText}>{playlist.copyright}</span>
        </div>
      </div>
    );
  }
}

export default injectIntl(PersonalPlaylistListItem);
